export default __webpack_public_path__ + "static/media/looker_icon.9bd086df.svg";